<template>
    <div class="wrapper">
        <h1 class="crumb">结算单报表</h1>
        <div class="bar">
            <div class="btnGroup">
                <el-button class="btn" @click="Report">结算单导出</el-button>
                <span style="margin-left:20px;">安装日期　</span>
                <el-date-picker
                    v-model="installDate"
                    type="daterange"
                    range-separator="至"
                    @change="getFinishList"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <span style="margin-left: 20px;">订单来源　</span>
                <el-select v-model="ddly" placeholder="请选择" style="width: 150px;" @change="getFinishList">
                    <el-option
                        v-for="item in ddlySelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>
                <!--<el-button class="btn" @click="searchOrder" style="margin-left: 20px">搜索</el-button>-->
                <el-select v-model="ssgn" placeholder="请选择" style="width: 150px;margin-left: 100px" @change="selectCompanys">
                    <el-option
                        v-for="item in ssgnSelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>
                <span><el-input v-model="searchKey" style="width: 200px" placeholder="请输入" v-show="isCompany === false"></el-input></span>
                <span v-show="isCompany === true">
                    <el-select v-model="searchKey" placeholder="公司名称" >
                            <el-option v-for="item in selectCompany" :label="item.company_name" :value="item.company_name" :key="item.name"></el-option>
                        </el-select>
                </span>
                <el-button class="btn" @click="getFinishList" style="">搜索</el-button>
            </div>
        </div>
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column type="index" align="center" width="40"></el-table-column>
            <el-table-column label="代理店" prop="store_name" align="center" sortable></el-table-column>
            <el-table-column label="型号" width="120" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods" style="font-size: 10px">{{item.goods_attr_select.length ===0?item.goods_attr:item.goods_attr_select[0]}}</div>
                </template>
            </el-table-column>
            <el-table-column label="数量" width="50" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods">{{item.goods_number}}</div>
                </template>
            </el-table-column>
            <el-table-column label="用户名" prop="consignee" align="center" ></el-table-column>
            <el-table-column label="用户电话" prop="mobile" align="center" ></el-table-column>
            <el-table-column label="用户地址"  align="center" show-overflow-tooltip="true">
                <template slot-scope="props">
                    {{props.row.address_all}}
                </template>
            </el-table-column>
            <el-table-column label="购买日期" prop="add_time" align="center" sortable></el-table-column>
            <el-table-column label="安装日期" prop="yuyue_time" align="center" sortable></el-table-column>
            <el-table-column label="安装公司名称" prop="company_name" align="center"></el-table-column>
            <el-table-column label="负责人" prop="company_contact" align="center"></el-table-column>
            <el-table-column label="备注" prop="comment" align="center"></el-table-column>
            <el-table-column label="商品价格" prop="order_amount" align="center"></el-table-column>
            <el-table-column label="安装价格" prop="jiesuan" align="center"></el-table-column>
            <!--<el-table-column label="完工日期" prop="finish_time" align="center" sortable></el-table-column>-->
            <!--<el-table-column label="操作" align="center">-->
            <!--<template slot-scope="props">-->
            <!--&lt;!&ndash;<a @click="xiapai(props.row)">下派</a>&ndash;&gt;-->
            <!--<a @click="orderDetails(props.row)">查看</a><a>　|　</a>-->
            <!--<a @click="orderDetails(props.row)">作废</a>-->
            <!--</template>-->
            <!--</el-table-column>-->
        </el-table>
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="10"
            layout=" total,prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
    import {getFinishList, getInstallCompany} from "../stores/api";

    export default {
        data () {
            return {
                dialogXiapai: false,
                page: 1,
                total: '',
                page_count: 1,
                tableData: [],
                selectCompany: [],
                isCompany: false, //搜索条件是否是安装公司
                ddlySelect: [{name: '全部', referer: ''}, {name: 'k3导入', referer: 'k3导入'}, {name: '新增', referer: '管理员添加'}, {name: 'PC商城', referer: 'PC'}, {name: '供应链', referer: '供应链'}, {name: '门店', referer: '门店'}, {name: '扫码', referer: '扫码'}],
                ddly: '',
                ssgnSelect: [{name: '合同订单号', referer: 'contract_number'}, {name: '客户电话', referer: 'mobile'}, {name: '安装公司', referer: 'company_name'}, {name: '型号', referer: 'goods_attr'}, {name: '业务员', referer: 'sale_name'}],
                ssgn: '合同号',
                searchKey: '',
                installDate: '', //安装日期搜索
            }
        },
        created() {
            this.getFinishList()
            this.getInstallCompanyList()
        },
        methods: {
            getFinishList() {
                let session_id = localStorage.getItem('shouhou_session_id')
                let temp = {}
                if (this.installDate !== '') {
                    temp.addtime1 = Date.parse(this.installDate[0].toLocaleDateString()).toString().slice(0, 10)
                    temp.addtime2 = Date.parse(this.installDate[1].toLocaleDateString()).toString().slice(0, 10)
                }
                temp.page = this.page
                temp.referer = this.ddly
                if (this.searchKey !== '') {
                    temp.ssgn = this.ssgn
                    temp.searchKey = this.searchKey
                }
                if (this.searchKey !== '') {
                    if (this.ssgn === 'contract_number') {
                        temp.contract_number = this.searchKey
                    } else if (this.ssgn === 'mobile') {
                        temp.mobile = this.searchKey
                    } else if (this.ssgn === 'company_name') {
                        temp.company_name = this.searchKey
                    } else if (this.ssgn === 'goods_attr') {
                        temp.goods_attr = this.searchKey
                    } else if (this.ssgn === 'sale_name') {
                        temp.sale_name = this.searchKey
                    }
                }
                getFinishList(temp).then(res => {
                    // console.log(res.data.install_list)
                    this.tableData = res.data.jiesuan
                    this.total = res.data.count
                    this.tableData.forEach((item, i) => {
                        this.tableData[i]['addr'] = item.province + item.city + item.district + item.address
                        this.tableData[i].goods.forEach((iem, k, i) => {
                            console.log(iem)
                            iem.goods_attr_select.forEach(item => {
                                console.log(item);
                            })
                        })
                    })
                })
            },
            handleCurrentChange(val) {
                this.page = val
                this.getFinishList()
            },
            //是否选择安装公司
            selectCompanys () {
                if (this.ssgn === 'company_name') {
                    this.isCompany = true
                    this.searchKey = this.selectCompany[0].company_name
                } else {
                    this.isCompany = false
                    this.searchKey = ''
                }
            },
            getInstallCompanyList () {
                getInstallCompany(this.page).then(res => {
                    this.selectCompany = []
                    this.selectCompany = res.data.company_list
                    this.page_count = res.data.page_count
                    if (this.page_count > 1) {
                        this.page = 2;
                        for (var i = 0; i < this.page_count - 1; i++) {
                            this.page += i;
                            getInstallCompany(this.page).then(res => {
                                res.data.company_list.forEach(item => {
                                    this.selectCompany.push(item)
                                })
                            })
                        }
                        // console.log(this.selectCompany)
                    }
                })
            },
            Report () {
                let temp = {}
                if (this.installDate !== '') {
                    temp.addtime1 = Date.parse(this.installDate[0].toLocaleDateString()).toString().slice(0, 10)
                    temp.addtime2 = Date.parse(this.installDate[1].toLocaleDateString()).toString().slice(0, 10)
                }
                temp.page = this.page
                temp.referer = this.ddly
                if (this.searchKey !== '') {
                    temp.ssgn = this.ssgn
                    temp.searchKey = this.searchKey
                }
                if (this.searchKey !== '') {
                    if (this.ssgn === 'contract_number') {
                        temp.contract_number = this.searchKey
                    } else if (this.ssgn === 'mobile') {
                        temp.mobile = this.searchKey
                    } else if (this.ssgn === 'company_name') {
                        temp.company_name = this.searchKey
                    } else if (this.ssgn === 'goods_attr') {
                        temp.goods_attr = this.searchKey
                    } else if (this.ssgn === 'sale_name') {
                        temp.sale_name = this.searchKey
                    }
                }
                var str = ''
                for (var key in temp) {
                    str += '&' + key + '=' + temp[key]
                }
                window.open(this.$reqUrl + `service.php?act=install_excel&session_id=${localStorage.getItem('shouhou_session_id')}${str}`)
                // this.$http.get(this.$reqUrl + `service.php?act=install_excel&session_id=${localStorage.getItem('shouhou_session_id')}`).then(res => {
                //
                // })
            },
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 0) {
                    return 'warning-row';
                } else if (rowIndex === 3) {
                    return 'success-row';
                }
                return '';
            }
        }
    }
</script>
<style lang="less" >
    .wrapper{
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            .btnGroup {
                button {
                    width: 100Px;
                    height: 35Px;
                    margin-right: 10Px;
                    font-size: 16px;
                    color: #ffffff;
                    background: #f56c31;
                    border-radius: 2px;
                }
            }
        }
    }

</style>
<style>
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
    .el-table th>.cell{
        color:#ea6625;
    }
</style>



// WEBPACK FOOTER //
// src/router/SettlementReportform.vue